import React from 'react';
import {connect} from "react-redux";
import {fetchActiveRegister} from "../../../../state/modules/register";
import {price} from "../../../../util/formatting";
import {photoSrc} from "../../../../util/media";
import {validateForm} from "../../../../util/validation";

import IconButton from "../../../atoms/icon-button";
import NumberInput from "../../../atoms/number-input";
import TextInput from "../../../atoms/text-input";
import ButtonGroup from "../../button-group";
import Form from "../../form";
import Label from "../../../atoms/label";
import StatusLabel from "../../../atoms/status-label";
import Button from "../../../atoms/button";

class CartItem extends React.Component {

    static defaultProps = {
        model: {},
        selected: false,
        onEdit: () => {
        },
        onCancel: () => {
        },
        onSave: () => {
        },
        onDelete: () => {
        },
        onQuantityChange: () => {
        }
    };
    
    constructor(props) {
        super(props);
        
        this.state = {
            price: this.props.model.override_price > 0 ? this.props.model.override_price : this.props.model.buyable.price,
            isEditing: false,
            isEditable: this.props.model.is_editable,
            isPreorder: this.props.model.buyable.is_preorder,
        };
    
        this.priceForm = React.createRef();
    }
    
    validatePriceForm(form, data) {
        validateForm(form, data, {
            override_price: ['required', 'number'],
        });
    }
    
    onEdit() {
        if (! this.state.isEditable) {
            return;
        }
        
        this.props.onEdit(this.props.model.id);

        this.setState({
            isEditing: true,
        });
    }
    
    onCancel() {
        this.props.onCancel(this.props.model.id);
        
        this.setState({
            isEditing: false,
        });
    }
    
    onSubmit(data) {
        if (! this.state.isEditable) {
            return;
        }
        
        let cart = this.props.model.cart;
        let cartItem = this.props.model;
        
        this.props.onSave(cart.id, cartItem, data);
    
        this.setState({
            isEditing: false,
        });
    }
    
    onQuantityChange(newQuantity) {
        this.props.onQuantityChange(this.props.model, newQuantity);
    }
    
    render() {
        let stock = null;
        
        if (this.props.model.buyable.stock_2) {
            stock = (
                <span> / {this.props.model.buyable.stock_2}</span>
            );
        }
        
        if (this.props.model.buyable.stocks) {
            const stockForCurrentLocation = this.props.model.buyable.stocks.find(stock => {
                return stock.location.id === this.props.activeRegister.location.id;
            });
            
            stock = (
                <div className="list-item__stock">
                    <NumberInput
                        min={null}
                        amount={this.props.model.quantity}
                        onChange={(newQuantity) => this.onQuantityChange(newQuantity)}
                    />
                </div>
            );
        }
        
        if (this.props.model.buyable.product_variation !== undefined) {
            return (
                <div className="list-item">
                    <div className="list-item__thumb">
                        <img src={photoSrc(this.props.model.buyable.thumbnail_url)} alt={this.props.model.buyable.product_variation.name}/>
                    </div>
                    <div
                        className="list-item__column list-item__column--valign-top list-item__column--clean list-item__column--span-5">
                        {this.props.model.buyable.title}<br/>
                        {this.props.model.buyable.subtitle}<br/>
                        {stock}
                    </div>
                    <div className="list-item__column list-item__column--span-2">
                        <span className={this.props.model.buyable.on_sale || this.props.model.override_price > 0 ? "list-item__price list-item__price--sale" : "list-item__price"}>
                            {this.props.model.original_price && price(this.props.model.original_price)}
                        </span>
                        {this.props.model.buyable.on_sale && !this.props.model.override_price > 0 &&
                            <span>{price(this.props.model.buyable.sale_price)}</span>
                        }
                        {this.props.model.override_price > 0 &&
                            <span className="list-item__price">{price(this.state.price)}</span>
                        }
                    </div>
                    <div className="list-item__column">
                        <IconButton iconType={'delete'} onClick={e => this.props.onDelete(this.props.model)}/>
                    </div>
                </div>
            );
        }

        else {
            return (
                <div className="list-item" onDoubleClick={() => this.onEdit()}>
                    <div className="list-item__thumb">
                        <img src={photoSrc(this.props.model.buyable.thumbnail_url)} alt={this.props.model.buyable.title}/>
                    </div>
                    <div
                        className="list-item__column list-item__column--valign-top list-item__column--clean list-item__column--span-5">
                        {this.props.model.buyable.title}<br/>
                        {this.props.model.buyable.subtitle}<br/>
                        {this.props.model.buyable.is_preorderable && <div><Label title="Pre-order"/></div>}
                    </div>
                    <div className="list-item__column list-item__column--span-3">
                        {(!this.state.isEditing || !this.props.selected) &&
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <span className={this.props.model.buyable.on_sale || this.props.model.override_price > 0 ? "list-item__price list-item__price--sale" : "list-item__price"}>
                                    {this.props.model.original_price && price(this.props.model.original_price)}
                                </span>
                                {this.props.model.buyable.on_sale && !this.props.model.override_price > 0 &&
                                    <span className="list-item__price">{price(this.props.model.buyable.sale_price)}</span>
                                }
                                {this.props.model.override_price > 0 &&
                                    <span className="list-item__price">{price(this.state.price)}</span>
                                }
                                <div style={{display: 'flex'}}>
                                    <IconButton iconType={'edit'} onClick={() => {
                                        this.onEdit()
                                    }}/>
                                    <IconButton iconType={'delete'} onClick={e => this.props.onDelete(this.props.model)}/>
                                </div>
                            </div>
                        }
                        {this.state.isEditing && this.props.selected &&
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <Form
                                    ref={this.priceForm}
                                    validate={(form, data) => this.validatePriceForm(form, data)}
                                    onSubmit={(data) => this.onSubmit(data)}
                                    showSubmitButton={false}
                                >
                                    <TextInput focus={this.props.selected} name="override_price" type="number" default={this.state.price} showRequiredIndicator={true} />
                                </Form>
                                <div style={{display: 'flex'}}>
                                    <IconButton iconType={'close'} onClick={() => this.onCancel()} />
                                    <IconButton iconType={'save'} onClick={() => {
                                        this.priceForm.current.submit()
                                    }} />
                                </div>
                            </div>
                        }
                    </div>
                    <div className="list-item__column list-item__column--span-2">
                        {stock}
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => ({
    activeRegister: state.register.activeRegister,
});

const mapDispatchToProps = {
    fetchActiveRegister: fetchActiveRegister,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItem);
